var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-dialog',{staticClass:"dialog-audit-task",attrs:{"title":"审核明细"},model:{value:(_vm.modelVisible),callback:function ($$v) {_vm.modelVisible=$$v},expression:"modelVisible"}},[_c('TableAuditTask',{attrs:{"billId":_vm.billId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }